import { combineReducers } from '@reduxjs/toolkit';
import { Map, fromJS } from 'immutable';
import PicabooConstants from '../common/PicabooConstants';

export const CONVERT_BACKGROUND = 'CONVERT_BACKGROUND';
export const SET_PREVIEW_COLOR = 'SET_PREVIEW_COLOR';
export const SET_BACKGROUND_IMAGE = 'SET_BACKGROUND_IMAGE';
export const SET_BACKGROUND_PATTERN = 'SET_BACKGROUND_PATTERN';
export const SET_BACKGROUND_COLOR = 'SET_BACKGROUND_COLOR';
export const SET_BACKGROUND_COLOR_UNDOABLE = 'SET_BACKGROUND_COLOR_UNDOABLE';
export const SET_BACKGROUND_COLOR_ALL_PAGES = 'SET_BACKGROUND_COLOR_ALL_PAGES';
export const SET_BACKGROUND_ALL_PAGES = 'SET_BACKGROUND_ALL_PAGES';

const initialState = {
  backgrounds: [],
  color: '',
  searchParams: {},
};

/**
 *  reducers
 */

// function selectedColor(state = new Map({color: initialState.color}), action){
//     let newState = state;
//     if (action.type == SET_BACKGROUND_COLOR){
//         return newState.set('color', action.color);
//     }
//     return state;
// }

function selectedPreviewColor(
  state = new Map({ color: initialState.color }),
  action,
) {
  let newState = state;
  if (action.type == SET_PREVIEW_COLOR) {
    return newState.set('color', action.color);
  }

  return state;
}

const backgroundsReducer = combineReducers({
  selectedPreviewColor,
});

/**
 *  actions
 */

export function setBackgroundImage(
  pages,
  pageItem,
  projectImage,
  imageID,
  otherItem = null,
) {
  return {
    type: SET_BACKGROUND_IMAGE,
    pageItem,
    image: projectImage,
    imageID,
    pages,
    otherItem,
    preferenceName: PicabooConstants.PREFERENCE_NAME.RECENTLY_USED_BACKGROUNDS,
  };
}
export function setBackgroundPattern(pages, pattern) {
  return {
    type: SET_BACKGROUND_PATTERN,
    pages,
    pattern,
  };
}
export function setBackgroundColor(
  pages,
  hexColor,
  undoable = true,
  event = null,
) {
  //if (event != null) logEvent('Background applied', 'test', 'test', 0);
  return {
    type: undoable ? SET_BACKGROUND_COLOR_UNDOABLE : SET_BACKGROUND_COLOR,
    color: hexColor,
    pages,
    preferenceName: PicabooConstants.PREFERENCE_NAME.RECENTLY_USED_COLORS,
  };
}

export function setBackgroundColorAllPages(sectionID, color) {
  return {
    type: SET_BACKGROUND_COLOR_ALL_PAGES,
    sectionID,
    color,
  };
}

export function convertBackground(background) {
  return {
    type: CONVERT_BACKGROUND,
    background,
  };
}

export function setBackgroundAllPages(pattern, sectionID) {
  return {
    type: SET_BACKGROUND_ALL_PAGES,
    pattern,
    sectionID,
  };
}

/**
 * Sagas
 */

function* setupSagas() {}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: backgroundsReducer,
  saga: setupSagas,
};
